import { render } from "./TasksDashboard.vue?vue&type=template&id=3c53d74c"
import script from "./TasksDashboard.vue?vue&type=script&lang=js"
export * from "./TasksDashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__